import { useEffect, useState } from 'react';
import { TbCircleLetterP } from 'react-icons/tb';
import PropTypes from 'prop-types';

import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import { colorForProgramPoints } from '../../../../../utils/dataStatus';

const ProgramPointButton = ({ dailyWorkReport, fetchData, handleChangedActions, selectedDate }) => {
  const { activeProgramPointApprovalModal } = useWorkReportModals();
  const [disabledButton, setDisabledButton] = useState(true);

  const handleOnClick = () => {
    activeProgramPointApprovalModal({
      daily: dailyWorkReport,
      fetchData,
      handleChangedActions,
      line: {
        positionName: dailyWorkReport?.posicionSap,
        lineName: dailyWorkReport?.lineaSap,
        idParteDiario: dailyWorkReport?.idParteDiario,
        estadoEnum: dailyWorkReport?.estadoEnum,
        tienePuntosPrograma: dailyWorkReport?.notificaPorPuntosPrograma,
        puntoPrograma: dailyWorkReport?.puntoPrograma,
        unidadMedida: dailyWorkReport?.unidadMedida,
        isApproval: true
      },
      defaultValue: false,
      dateSelect: selectedDate
    });
  };

  useEffect(() => {
    if (
      !dailyWorkReport?.notificaPorPuntosPrograma ||
      (dailyWorkReport?.notificaPorPuntosPrograma &&
        !dailyWorkReport?.variosPuntosPrograma &&
        dailyWorkReport?.puntoPrograma === null)
    )
      setDisabledButton(true);
    else setDisabledButton(false);
  }, [dailyWorkReport]);

  const showProgramPoints = () => {
    if (dailyWorkReport?.notificaPorPuntosPrograma) {
      if (dailyWorkReport?.variosPuntosPrograma) {
        return (
          <TbCircleLetterP
            color={colorForProgramPoints.withPP}
            size={25}
            style={{ backgroundColor: 'transparent' }}
          />
        );
      }
      if (dailyWorkReport.puntoPrograma) {
        return <span style={{ fontWeight: '400 ' }}>{dailyWorkReport.puntoPrograma}</span>;
      }

      return <TbCircleLetterP color={colorForProgramPoints.disabledPP} size={25} />;
    }

    return <TbCircleLetterP color={colorForProgramPoints.disabledPP} size={25} />;
  };

  return (
    <>
      <ComponentWithTooltip id="hidden-tooltip-pp" tooltipText="Puntos de Programa">
        <div>
          <button
            aria-label="Punto Programa"
            disabled={disabledButton}
            onClick={handleOnClick}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: !disabledButton ? 'pointer' : 'default'
            }}
            type="button"
          >
            {showProgramPoints()}
          </button>
        </div>
      </ComponentWithTooltip>
    </>
  );
};

export default ProgramPointButton;

ProgramPointButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport,
  fetchData: PropTypes.func,
  handleChangedActions: PropTypes.func,
  selectedDate: PropTypes.string
};

ProgramPointButton.defaultProps = {
  dailyWorkReport: {},
  fetchData: () => {},
  handleChangedActions: () => {},
  selectedDate: ''
};
